import { render, staticRenderFns } from "./main_view.vue?vue&type=template&id=53ceebf3&scoped=true"
var script = {}
import style0 from "./main_view.vue?vue&type=style&index=0&id=53ceebf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ceebf3",
  null
  
)

export default component.exports